/**
 * Check if the date is in the future
 */
export const dateAfterValidator = (value: string, { min }: Record<string, any>) => {
  return new Date(value) >= new Date(min)
}

